<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>LISTADO DE OFERTAS DE LICITACIÓN</h1>
                    <p class="mt-3">
                        Ayúdanos a elegir a que familia de productos perteneces.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-ofertas']" class="nav-link m-1 disabled" tabindex="-1" aria-disabled="true">Listado de ofertas</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-proveedor']" class="nav-link m-1">Mis postulaciones</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-registro']" class="nav-link m-1"> Actualizar registro </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-contrasena']" class="nav-link m-1"> Actualizar Contraseña </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/login']" class="nav-link cerrar m-1 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pt-5">
            <div class="col-12 mb-1">
                <div class="row FlstLi mb-2">
                    <div class="col-12 col-md-2 text-center mx-auto mt-4">
                        <button type="submit" class="mr-2" (click)="gopro()"> Recargar </button>
                    </div>
                    <div class="col-12 col-md-5 text-left my-2">
                        <label>Selecciona una familia de productos</label>
                        <select ngModel name="familiaid" class="form-control" (ngModelChange)="productosShareFamily($event)" required>
                            <option *ngFor="let familia of familias" [ngValue]="familia.id"  > {{ familia.familia }}
                            </option>
                        </select> 
                    </div>
                    <div class="col-12 col-md-5 text-left my-2">
                            <label>Buscar por nombre o código</label>
                            <input #inputstring  (blur)="onBlur($event)" (keyup)="buscador(inputstring .value)" autocomplete="off"  type="text" class="form-control buscador" />
                    </div>
                 
                </div>
            </div>
        </div>
        <div class="row pb-5">
            <div class="col-12 text-center mx-auto">

                <div class="FlstLi table-responsive">
                    <table class="Ftabla Ftablon table dDoce">
                        <tr>
                            <!-- <th scope="col" class="pl-2 pr-2">No.</th> -->
                            <th scope="col" class="pl-2 pr-2">Código</th>
                            <th scope="col" class="pl-2 pr-2">Producto</th>
                            <th scope="col" class="pl-2 pr-2">Fecha publicación</th>
                            <th scope="col" class="pl-2 pr-2">Archivo ficha técnica</th>
                            <th scope="col" class="pl-2 pr-2">Detalle oferta</th>
                            <th scope="col" class="pl-2 pr-2">Familia</th><th scope="col">Participar</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq">
                            <tr *ngFor="let oferta of ofertas">
                                <td>{{oferta.codigo}}</td>
                                <td>{{oferta.producto}}</td>
                                <td>{{oferta.fechaPublicacion | date: 'dd-MM-yyyy hh:mm'}}</td>
                                <td>
                                    <a href="https://fundacionbest.org.mx/Webapi{{oferta.urlFichaTecnica}}" target="_blank" rel="noopener">
                                        <img src="../../../assets/images/icons/ficha-tecnica.svg" class="ficha">
                                    </a>
                                </td>
                                <td>{{oferta.detalleOferta}}</td>
                                <td>{{oferta.familia}}</td>
                                <td class="pl-2 pr-2 align-middle"> 
                                    <div class="form-group col-sm-12 pt-1 m-0 text-center">
                                        <button (click)="goPostulacion(oferta)" class="btn-aceptar"> Aceptar </button>
                                    </div>
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-12 alerta-confirmar blqCtr text-center" *ngIf="this.confirma">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-confirmar.png">
            <p>Esta a punto de <strong>registrar</strong> una participación por la oferta seleccionada, <strong>¿desea continuar?</strong></p>
            <button class="mr-2" (click)="goChange()"> Confirmar</button>
            <button class="ml-2 greyBtn" (click)="cancel()"> Cancelar</button>
        </div>
        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-exito.png">
            <p><strong>Gracias</strong> por su interés en participar con nosotros, el área correspondiente <strong>revisará su información</strong> y en caso de ser seleccionado recibirá una <strong>notifición</strong> vía correo electrónico</p>
            <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
        </div>
        <div class="col-12 alerta-registro blqCtr text-center" *ngIf="this.fail">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p [innerHTML]="theHtmlString"></p>
            <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
        </div>

	</div>

</div>